import type { BoomRngV1 } from './rng';

const FIRST = [
  'Abe', 'Ada', 'Amos', 'Bea', 'Bert', 'Cass', 'Clem', 'Cora', 'Dell', 'Dora',
  'Earl', 'Edna', 'Eli', 'Etta', 'Fern', 'Gus', 'Hank', 'Hazel', 'Ike', 'Ida',
  'Jed', 'June', 'Knox', 'Lena', 'Levi', 'Mae', 'Mose', 'Nell', 'Otis', 'Opal',
  'Pete', 'Pearl', 'Quinn', 'Rose', 'Rufe', 'Sadie', 'Silas', 'Tess', 'Virg', 'Wade',
] as const;

const LAST = [
  'Ashford', 'Barlow', 'Beckett', 'Boone', 'Calhoun', 'Carver', 'Colter', 'Crane',
  'Dalton', 'Dunn', 'Eastwood', 'Fairbank', 'Garrett', 'Granger', 'Hale', 'Harlan',
  'Holt', 'Ives', 'Jessup', 'Keller', 'Lang', 'Larkin', 'Marsh', 'McCabe',
  'Nash', 'Oakes', 'Pruitt', 'Quimby', 'Redd', 'Ruiz', 'Sloan', 'Stroud',
  'Tate', 'Thorne', 'Vance', 'Walsh', 'Weber', 'Whitlock', 'York', 'Zeller',
] as const;

export function peepName(rng: BoomRngV1): string {
  return `${rng.pick(FIRST)} ${rng.pick(LAST)}`;
}
